import RenewalEntryCtrl from '../entry/RenewalEntryCtrl';
import RenewalEntryView from 'text!gw-portals-policytransaction-common-angular/transactionEntry/transactionEntry.html';

export default function () {

    var parentState = 'root';

    return {
        renewalTransactionEntry: {
            parent: parentState,
            url: '/renewalTransaction/{selectedPolicyNumber}?day&month&year',
            controller: RenewalEntryCtrl,
            template: RenewalEntryView,
            params: {
                selectedPolicyNumber: null,
                selectedRenewal: null,
                resume: true
            }
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-renewal-angular/config/RouteConfig.js
// module id = 1871
// module chunks = 0